import { DataBean } from "../DataBean";

export class TaxMovement extends DataBean {


    public async createPaymentOrderTaxMovement(costingCenterCode:any,idBusinessCore:any,idProject:any,value:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.Map_createPaymentOrderTaxMovement_String_Number_Number_Number", [costingCenterCode,idBusinessCore,idProject,value]);
    }


}